module.exports = __webpack_public_path__ + "img/Treat_item_off_icon.bdb051ed.svg";